import axios from 'axios'

import { authenticatedRequestInterceptor } from '../../../interceptors/http-interceptor/authenticated'
import { authenticatedErrorResponseInterceptor } from '../../../interceptors/http-interceptor/errorAuthenticated'
import { errorRequestInterceptor } from '../../../interceptors/http-interceptor/errorRequest'
import { responseInterceptor } from '../../../interceptors/http-interceptor/response'

export const configureAuthenticatedAPI = (
  url: string,
  apiKey?: string,
  useInterceptors?: boolean
) => {
  const instance = axios.create({
    headers: { Authorization: apiKey ? `${apiKey}` : undefined },
    baseURL: url
  })

  if (useInterceptors) {
    instance.interceptors.request.use(
      authenticatedRequestInterceptor,
      errorRequestInterceptor
    )
    instance.interceptors.response.use(
      responseInterceptor,
      authenticatedErrorResponseInterceptor
    )
  }

  return instance
}
